import styled from 'styled-components';

export const FotosContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-height: 300px;
`;

export const FotosRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
`;

export const ImageContainer = styled.div`
    width: 135px;
    height: 115px;
    background-color: red;
    margin: 10px;
    border-radius: 8%;
    overflow: hidden;
`;
export const BorderIcon = styled.button`
    cursor: pointer;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: lightgrey;
    margin-left: -25px;
    position: absolute;
    top: -10px;
    right: -10px;
`;

export const ImageSizeContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 130px;
    height: fit-content;
    background-color: transparent;
    position: relative;
    margin: 10px;
`;

export const Img = styled.img`
    height: 100px;
    width: 130px;
    border-radius: 8px;
    object-fit: scale-down;
`;
export const PlusImage = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 119px;
    height: 90px;
    background-color: white;
    margin: 10px;
    border-radius: 8px;
    border: 1px dashed grey;
    padding: 4px;
    user-select: none;

    &:hover {
        opacity: 0.5;
        cursor: pointer;
    }
`;

export const InputImage = styled.input`
    display: none;
`;

export const ImageText = styled.span`
    font-size: 16px;
    color: grey;
    text-align: center;
`;
